import { Card } from '@/components/generic';

// const socials = [
//   {
//     icon: 'telegram',
//     href: 'https://t.me/Xhype_Support',
//   },
// ];

const GetMoreCustomers = () => {
  return (
    <Card title='Need help or have questions?'>
      <div className='mb-6 px-5 text-body-2 text-t-secondary max-lg:px-3'>
        Our support team is one message away. <br></br>Reach out and we’ll get
        you sorted. 🔥
      </div>
      {/* <div className='flex gap-3'>
        {socials.map((social, index) => (
          <Button
            className='flex-1 !px-0'
            icon={social.icon}
            key={index}
            isStroke
            as='a'
            href={social.href}
            target='_blank'
            rel='noopener noreferrer'
          />
        ))}
      </div> */}
    </Card>
  );
};

export default GetMoreCustomers;
